<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col>
          <v-row justify="center">
            <div
              v-for="item in filteredBrands"
              :key="item.id"
              class="lg5-custom"
              justify="start"
            >
              <v-card height="180" @click="brand(item)">
                <div class="imgContainer align-center ma-1">
                  <img
                    class="img"
                    :src="source(url, item.image)"
                    :alt="item.name"
                  />
                </div>

                <v-card-text
                  class="d-flex align-center justify-center pa-1"
                  align="center"
                >
                  {{ item.name }}
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { getImageURL } from "../../utils/shoppingCart.js";

export default {
  name: "brands",

  components: {},

  data() {
    return {
      brands: [],
      filteredBrands: [],
      url: "https://risoulimages.s3-us-west-2.amazonaws.com/MARCAS/",
      source: getImageURL,
    };
  },

  props: {
    sendSnack: { type: Function },
  },

  methods: {
    brand: function (item) {
      var select = item.name;
      var idSelected = item.id;
      // if(item.name == "ALLEN BRADLEY"){
      //   this.sendSnack("Por el momento esta marca no esta disponible desde este menú")
      // }else{
      this.$router.push(
        "/products/brands/" + select + "?brandId=" + idSelected
      );
      // }
    },

    getBrands: function () {
      this.$http.get(`brand/`).then(
        (response) => {
          var list = response.body.data;
          this.brands = list.filter(function (item) {
            return item.image.length > 0;
          });
          this.filteredBrands = this.brands;

          this.loading = false;
        },
        (error) => {
          this.snackbar(
            error.message || "Hubo un problema al obtener la lista de marcas"
          );
          console.error(error);
        }
      );
    },
  },

  computed: {},

  watch: {
    "$route.query": function () {
      this.$router.go();
    },
  },

  created() {
    document.title = "Risoul - Marcas";
    this.getBrands();
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.img {
  width: 100%;
  height: auto;
  max-height: 130px;
}
.imgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 130px;
}
</style>
